import { startsWith } from '@enonic/js-utils/string/startsWith';

const BR = '<br/>';

export function addBulletPoints(text: string): string {
	const lines = text.split('\n');
	let result = '';
	let inList = false;

	for (const line of lines) {
		if (startsWith(line.trim(),'- ')) {
			if (!inList) {
				result += '<ul>\n'; // sanitizeHtml doesn't allow class on ul.
				inList = true;
			}
			result += `  <li>${line.trim().substring(2)}</li>\n`;
		} else {
			if (inList) {
				result += '</ul>\n';
				inList = false;
			}
			result += `${line}${BR}`;
		}
	}

	if (inList) {
		result += '</ul>\n';
	}

	return result;
}
